export const TIME_FILTER_TYPE = Object.freeze({
  NONE: -1,
  SLIDER: 0,
  DROPDOWN: 1,
});

export const TIME_FILTER_OPTIONS = Object.freeze([
  { value: "all", label: "All" },
  { value: "last_5_years", label: "Last 5 years" },
  { value: "last_10_years", label: "Last 10 years" },
]);

export const EXPORT_FORMAT = Object.freeze({
  CSV: "CSV",
  PLAIN_TEXT: "TXT",
  CLIPBOARD: "Clipboard",
});

export const EXPORT_TYPE = Object.freeze({
  10: 10,
  25: 25,
  50: 50,
  100: 100,
  500: 500,
  CURRENT_PAGE: "Search results on current page",
  ALL: "All search results",
});

export const COLLABORATION_REPORT_SECTIONS = [
  // --- General ---
  { key: "general_kpis", label: "Overview KPIs", tab: "general", defaultChecked: true },
  { key: "general_insights", label: "Key Observations", tab: "general", defaultChecked: true },
  { key: "general_scope", label: "Collaboration Scope", tab: "general", defaultChecked: true },
  { key: "general_trends", label: "Collaboration Trends", tab: "general", defaultChecked: true },
  { key: "general_reach", label: "Geographic Reach", tab: "general", defaultChecked: false },
  { key: "general_subjects", label: "Subject Areas", tab: "general", defaultChecked: false },
  // --- Current ---
  { key: "current_facts", label: "Network Signals", tab: "current", defaultChecked: true },
  { key: "current_table", label: "Current Collaborators Table", tab: "current", defaultChecked: true },
  // --- Potential ---
  { key: "potential_kpis", label: "Opportunity KPIs", tab: "potential", defaultChecked: true },
  { key: "potential_insights", label: "Strategic Insights", tab: "potential", defaultChecked: true },
  { key: "potential_table", label: "Top Potential Partners", tab: "potential", defaultChecked: true },
];

export const ANALYSIS_REPORT_SECTIONS = [
  // --- Table View ---
  { key: "table_metrics", label: "Benchmarking Metrics Table", tab: "table", defaultChecked: true },
  // --- Visual View ---
  { key: "visual_trend", label: "Trend Evolution (Line Chart)", tab: "visual", defaultChecked: true },
  { key: "visual_growth", label: "Growth Momentum (Bar Chart)", tab: "visual", defaultChecked: true },
  { key: "visual_radar", label: "Strength Profile (Radar Chart)", tab: "visual", defaultChecked: true },
  { key: "visual_scatter", label: "Volume vs. Quality (Scatter Chart)", tab: "visual", defaultChecked: true },
  { key: "visual_quality", label: "Impact Quality (Grouped Bar Chart)", tab: "visual", defaultChecked: true },
  { key: "visual_ranking", label: "Peer Ranking Strip (Horizontal Bar)", tab: "visual", defaultChecked: true },
];

export const ANALYSIS_TREND_METRICS = [
  { value: "total_pubs", label: "Total Publications" },
  { value: "pubs_per_faculty", label: "Publications / Faculty" },
  { value: "total_citations", label: "Total Citations" },
  { value: "citations_per_faculty", label: "Citations / Faculty" },
  { value: "citations_per_paper", label: "Citations / Paper" },
  { value: "h_index", label: "H-Index" },
  { value: "total_grant_amount", label: "Total Grant Funding ($)" },
  { value: "grant_amount_per_faculty", label: "Grant Amount/ Faculty ($)" },
  { value: "int_collab", label: "International Collaborations" },
];

export const ANALYSIS_RADAR_METRICS = [
  { value: "total_pubs", label: "Publications" },
  { value: "total_citations", label: "Citations" },
  { value: "h_index", label: "H-Index" },
  { value: "total_grant_amount", label: "Grant ($)" },
  { value: "int_collab", label: "Collabs" },
  { value: "active_researchers", label: "Researchers" },
  { value: "median_citations_per_paper", label: "Median Cites/Paper" },
  { value: "pct_top10_cited", label: "% Top 10% Cited" },
  { value: "g_index", label: "G-Index" },
  { value: "pubs_per_faculty", label: "Pubs/Faculty" },
];

export const ANALYSIS_SCATTER_Y_METRICS = [
  { value: "median_citations_per_paper", label: "Median Citations / Paper" },
  { value: "pct_top10_cited", label: "% in Top 10% Cited" },
  { value: "pct_cited_papers", label: "% Cited Papers" },
  { value: "h_index", label: "H-Index" },
  { value: "specialization_index", label: "Specialization Index" },
];

export const ANALYSIS_SCATTER_Z_METRICS = [
  { value: "total_grant_amount", label: "Amount Awarded ($)" },
  { value: "faculty_count", label: "Faculty Count" },
  { value: "active_researchers", label: "Active Researchers" },
];

export const ANALYSIS_QUALITY_GROUPS = [
  { value: "groupA", label: "Citation Quality (%) — % Cited, Top 10%, Top 1%, 5-yr Share" },
  { value: "groupB", label: "Impact Indices — H, H5, H10, i10, G-Index" },
];

export const ANALYSIS_RANKING_METRICS = [
  { value: "total_pubs", label: "Publication Count" },
  { value: "total_citations", label: "Citation Count" },
  { value: "total_grant", label: "Grants" },
  { value: "total_grant_amount", label: "Amount Awarded ($)" },
  { value: "faculty_count", label: "Faculty Count" },
  { value: "active_researchers", label: "Active Researchers" },
  { value: "h_index", label: "H-Index" },
  { value: "h5_index", label: "H5-Index" },
  { value: "h10_index", label: "H10-Index" },
  { value: "i10_index", label: "i10-Index" },
  { value: "g_index", label: "G-Index" },
  { value: "median_citations_per_paper", label: "Median Citations / Paper" },
  { value: "pct_cited_papers", label: "% Cited Papers" },
  { value: "pct_top10_cited", label: "% in Top 10% Cited" },
  { value: "pct_top1_cited", label: "% in Top 1% Cited" },
  { value: "pubs_per_faculty", label: "Publications / Faculty" },
  { value: "pubs_per_active_researcher", label: "Publications / Active Researcher" },
  { value: "median_pubs_per_researcher", label: "Median Publications / Researcher" },
  { value: "avg_pubs_per_year", label: "Average Publications / Year" },
  { value: "recent_5yr_share", label: "Recent 5-yr Publication Share" },
  { value: "pub_cagr", label: "Publication CAGR" },
  { value: "int_collab_countries", label: "Collaborating Countries" },
];

export const ANALYSIS_SORT_MAP = Object.freeze({
  totalPubs: 'total_pubs',
  pubsPerFaculty: 'pubs_per_faculty',
  totalCitations: 'total_citations',
  citationsPerFaculty: 'citations_per_faculty',
  citationsPerPaper: 'citations_per_paper',
  hIndex: 'h_index',
  h5Index: 'h5_index',
  h10Index: 'h10_index',
  i10Index: 'i10_index',
  gIndex: 'g_index',
  medCitPaper: 'median_citations_per_paper',
  pctCited: 'pct_cited_papers',
  pctTop10: 'pct_top10_cited',
  pctTop1: 'pct_top1_cited',
  medPubsPerRes: 'median_pubs_per_researcher',
  recent5yrShare: 'recent_5yr_share',
  pubCagr: 'pub_cagr',
  avgPubsPerYear: 'avg_pubs_per_year',
  facultyCount: 'faculty_count',
  activeResearchers: 'active_researchers',
  pubsPerActiveRes: 'pubs_per_active_researcher',
  totalGrant: 'total_grant',
  totalGrantAmount: 'total_grant_amount',
  grantPerFaculty: 'grant_amount_per_faculty',
  intCollab: 'int_collab',
  intCollabCountries: 'int_collab_countries',
});

export const ANALYSIS_METRIC_META = Object.freeze({
  total_pubs: { label: "Total Publications", type: "count" },
  pubs_per_faculty: { label: "Publications / Faculty", type: "decimal" },
  total_citations: { label: "Total Citations", type: "count" },
  citations_per_faculty: { label: "Citations / Faculty", type: "decimal" },
  citations_per_paper: { label: "Citations / Paper", type: "decimal" },
  h_index: { label: "H-Index", type: "count" },
  h5_index: { label: "H5-Index", type: "count" },
  h10_index: { label: "H10-Index", type: "count" },
  i10_index: { label: "i10-Index", type: "count" },
  g_index: { label: "G-Index", type: "count" },
  median_citations_per_paper: { label: "Median Citations / Paper", type: "decimal" },
  pct_cited_papers: { label: "% Cited Papers", type: "percent" },
  pct_top10_cited: { label: "% in Top 10% Cited", type: "percent" },
  pct_top1_cited: { label: "% in Top 1% Cited", type: "percent" },
  recent_5yr_share: { label: "Recent 5-yr Publication Share", type: "percent" },
  pub_cagr: { label: "Publication CAGR", type: "percent" },
  avg_pubs_per_year: { label: "Average Publications / Year", type: "decimal" },
  faculty_count: { label: "Faculty Count", type: "count" },
  active_researchers: { label: "Active Researchers", type: "count" },
  pubs_per_active_researcher: { label: "Publications / Active Researcher", type: "decimal" },
  median_pubs_per_researcher: { label: "Median Publications / Researcher", type: "decimal" },
  total_grant: { label: "Total Grants", type: "count" },
  total_grant_amount: { label: "Amount Awarded ($)", type: "currency" },
  grant_amount_per_faculty: { label: "Grant Amount/ Faculty ($)", type: "currency" },
  int_collab: { label: "International Collaborations", type: "count" },
  int_collab_countries: { label: "Collaborating Countries", type: "count" },
  specialization_index: { label: "Specialization Index", type: "decimal" },
});

export const ANALYSIS_METRIC_CATEGORIES = Object.freeze([
  {
    key: "pubs_and_citations",
    label: "Publications & Citations",
    metrics: [
      "total_pubs",
      "pubs_per_faculty",
      "total_citations",
      "citations_per_faculty",
      "citations_per_paper",
      "avg_pubs_per_year",
      "pub_cagr",
      "recent_5yr_share",
    ],
  },
  {
    key: "indices_and_quality",
    label: "Citation Impact & Quality Indices",
    metrics: [
      "h_index",
      "h5_index",
      "h10_index",
      "i10_index",
      "g_index",
      "median_citations_per_paper",
      "pct_cited_papers",
      "pct_top10_cited",
      "pct_top1_cited",
      "specialization_index",
    ],
  },
  {
    key: "workforce",
    label: "Workforce & Research Activity",
    metrics: [
      "faculty_count",
      "active_researchers",
      "pubs_per_active_researcher",
      "median_pubs_per_researcher",
    ],
  },
  {
    key: "funding_and_collab",
    label: "Funding & Collaborations",
    metrics: [
      "total_grant",
      "total_grant_amount",
      "grant_amount_per_faculty",
      "int_collab",
      "int_collab_countries",
    ],
  },
]);


